// src/whatsappChat/components/Modal.jsx
import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

/**
 * Rendered in place (not in a portal) so it stays inside .wa-chat-container
 * and inherits the module's tokens.
 */
export function Modal({ title, badge, onClose, locked = false, wide = false, children, footer }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape' && !locked) onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose, locked]);

  return (
    <div
      className="wa-modal-backdrop"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget && !locked) onClose();
      }}
    >
      <div className={`wa-modal${wide ? ' is-wide' : ''}`} role="dialog" aria-modal="true" aria-label={title}>
        <header className="wa-modal-head">
          <div className="wa-modal-heading">
            <h2>{title}</h2>
            {badge}
          </div>
          <button type="button" className="wa-icon-btn" onClick={onClose} disabled={locked} aria-label="Close">
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </header>
        <div className="wa-modal-body">{children}</div>
        {footer && <footer className="wa-modal-foot">{footer}</footer>}
      </div>
    </div>
  );
}

export function Field({ label, hint, error, count, max, children }) {
  return (
    <label className="wa-field">
      <span className="wa-field-label">
        <span>{label}</span>
        {max != null && (
          <span className={`wa-field-count${count > max ? ' is-over' : ''}`}>
            {count}/{max}
          </span>
        )}
      </span>
      {children}
      {error ? <span className="wa-field-error">{error}</span> : hint && <span className="wa-field-hint">{hint}</span>}
    </label>
  );
}
